import React from 'react';
import PropTypes from 'prop-types';

import { OKTableRow } from 'commonsComponents/OKTableRow';
import { OKTableCell } from 'commonsComponents/OKTableCell';

import { OneLineSymbolAmount } from 'commonsComponents/oneLineSymbolAmount';
import { LabelDate } from 'commonsComponents/labelDate';

const { getLanguage } = require('core/i18n').i18n;

import { toCamelCase } from 'utilities/stringHelper';
import { formatAmountObject, getPlainAmountObject } from 'utilities/currencyHelper';

import { LABEL_DATE_TODAY, LABEL_DATE_YESTERDAY } from 'constants/commonsComponents';
import CategoryTableCell from 'components/commons/categoryTableCell/categoryTableCell';

import { getCategoryIconURL } from 'utilities/expensesByCategories/categoriesUtilities';
const { getCategoryIcon } = require('constants/categories');
import { NOT_ALLOWED_TINK_AGGREGATOR } from 'constants/flagBasedFeatures';

const language = getLanguage();
const { AGGREGATOR_NEW_FEATURES } = require('constants/flagBasedFeatures');

class AggregatorAccountMovementsTableRow extends React.PureComponent {
  constructor(props) {
    super(props);
  }

  render() {
    const { immTransaction, immFlagBasedFeatures } = this.props;
    const isTinkAggregator = immFlagBasedFeatures.get(NOT_ALLOWED_TINK_AGGREGATOR);

    const AGGREGATOR_V2 = immFlagBasedFeatures.get(AGGREGATOR_NEW_FEATURES);
    const dateRowClass = 'aggregator-movements-view__table__row__cell-date';
    const category = isTinkAggregator
      ? immTransaction.getIn(['category', 'categoryCode'])
      : immTransaction.get('category');
    const subCategory = isTinkAggregator
      ? immTransaction.getIn(['category', 'subcategoryCode'])
      : immTransaction.get('subCategory');
    const description = isTinkAggregator
      ? toCamelCase(immTransaction.get('concept'))
      : toCamelCase(immTransaction.get('description'));
    const plainAmountObject = getPlainAmountObject(
      isTinkAggregator ? immTransaction.get('amount') : immTransaction.get('quantity')
    );
    const plainAmountTotalObject = getPlainAmountObject(
      isTinkAggregator ? immTransaction.get('balance') : immTransaction.get('amount')
    );

    const iconCategory = isTinkAggregator
      ? getCategoryIconURL(`category_${category}`)
      : AGGREGATOR_V2
      ? immTransaction.get('categoryIconUrl')
      : getCategoryIcon(category);

    return (
      <OKTableRow>
        <OKTableCell className={dateRowClass}>
          <LabelDate
            date={immTransaction.get('date')}
            language={language}
            today={LABEL_DATE_TODAY}
            yesterday={LABEL_DATE_YESTERDAY}
          />
        </OKTableCell>
        <OKTableCell className="account-last-movements-table-row__cell-category">
          <CategoryTableCell
            category={category}
            subcategory={subCategory}
            iconCategory={AGGREGATOR_V2 && iconCategory}
            newCategorized={AGGREGATOR_V2}
          />
        </OKTableCell>
        <OKTableCell className="account-last-movements-table-row__cell-description">
          <span>{description}</span>
        </OKTableCell>
        <OKTableCell className="account-last-movements-table-row__cell-balance">
          <OneLineSymbolAmount
            amountObject={plainAmountObject}
            language={language}
            amountObjectFormatted={formatAmountObject(plainAmountObject, true)}
          />
        </OKTableCell>
        <OKTableCell className="account-last-movements-table-row__cell-total-balance">
          <OneLineSymbolAmount
            amountObject={plainAmountTotalObject}
            language={language}
            amountObjectFormatted={formatAmountObject(plainAmountTotalObject, true)}
          />
        </OKTableCell>
      </OKTableRow>
    );
  }
}

AggregatorAccountMovementsTableRow.propTypes = {
  immTransaction: PropTypes.object,
  immFlagBasedFeatures: PropTypes.object,
};

export { AggregatorAccountMovementsTableRow };
